import React, { Component } from 'react'
import Translation from '../General/Translation'

class SiteNavigationMoreButton extends Component {
    constructor(props) {
        super(props)
        this.siteNavigationMoreButton = React.createRef()
    }

    componentDidMount() {
        const {getMoreButtonWidth} = this.props
        getMoreButtonWidth(this.siteNavigationMoreButton.current)

        window.addEventListener("resize", () => {getMoreButtonWidth(this.siteNavigationMoreButton.current)})
    }

    componentWillUnmount() {
        const {getMoreButtonWidth} = this.props
        window.removeEventListener("resize", () => {getMoreButtonWidth()})
    }

    render() {
        const {onClick, hiddenMenuOpen, translation} = this.props
        const buttonText = hiddenMenuOpen ? <Translation id="less" trans={translation}>WENIGER</Translation> : <Translation id="more" trans={translation}>MEHR</Translation>
        return (
            <li onClick={onClick} ref={this.siteNavigationMoreButton} className="menu-item">
                <p><span className="menu-item-link text-medium-navigation cursor-pointer">{buttonText}</span></p>
            </li>
        )
    }

}

export default SiteNavigationMoreButton